import { staticColors } from '../../const/colors/staticColors';
import { sizes } from '../../const/sizes';
export const TABLE_BORDER_STYLE = `${sizes.table.borderThickness} solid ${staticColors.tableBorder}`;
export const TABLE_HEADER_BORDER_STYLE = `${sizes.table.borderThickness} solid ${staticColors.tableHeaderBackground}`;
export const SIDE_TABLE_BORDER_STYLE = `${sizes.table.borderThickness} solid ${staticColors.sideTableBorder}`;
export const tableCellBackgroundMap = {
    default: undefined,
    gray: staticColors.tableCellBackgroundGray,
};
